import { generateEmailHeading2 } from "../../generateEmailParagraph"

export const getOpenCoursesOffer = (courseListOffer: string): string => {
  if (courseListOffer.length === 0) {
    return ""
  }

  return `
    ${generateEmailHeading2("Aktuálně naše další otevřené kurzy", "https://vzdelanibudoucnosti.cz/pocitacove-krouzky-pro-deti", "margin-bottom: -15px;")}
    ${courseListOffer}
  `
}
